export function toNum(v) {
  if (v === undefined || v === null || v === '') return null;
  const n = parseFloat(String(v).replace(/,/g, ''));
  return Number.isFinite(n) ? n : null;
}

export function parseDate(v) {
  if (!v) return null;
  const s = String(v).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const m = s.match(/^(\d{2})\/(\d{2})\/(\d{2,4})$/);
  if (!m) return null;
  const [, d, mo, y] = m;
  const yyyy = y.length === 2 ? `20${y}` : y;
  return `${yyyy}-${mo}-${d}`;
}

export function normaliseEposRow(row, orgId, userId) {
  // Required
  const sku = (row?.PLU || '').toString().trim();
  const name = (row?.DESC || '').toString().trim();
  const cost = toNum(row?.COST);
  if (!sku || !name || cost === null) return null;

  return {
    org_id: orgId,
    sku,
    name,
    supplier_code: (row?.SUPP || null) ? String(row.SUPP) : null,
    supplier_product_code: (row?.SUPPCODE || null) ? String(row.SUPPCODE) : null,
    current_price: cost,
    vat_rate: toNum(row?.VATRATE),
    vat_code: row?.VATCODE ? String(row.VATCODE) : null,
    stock_qty: toNum(row?.STOCK),
    case_qty: toNum(row?.CASEQTY),
    case_cost: toNum(row?.CASECOST),
    last_sold_at: parseDate(row?.LASTSOLD),
    updated_by: userId,
    last_validated_at: new Date().toISOString()
  };
}

